module.exports = __webpack_public_path__ + "static/fonts/NotoSans-DemiLight.01d4df1.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/views/myprotein-test/assets/fonts/NotoSans-DemiLight.woff2
// module id = eh+R
// module chunks = 0